import HttpService from './HttpService';
import { PROJECT_PATH } from '../url';
import ErrorSwitchCase from './ErrorHandlerService';
const _axios = HttpService.getAxiosClient();

export const createTask = async (task) => {
  try {
    const response = await _axios.post(`${PROJECT_PATH}/tasks`, task);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const updateTask = async (updatedTask) => {
  try {
    const response = await _axios.put(`${PROJECT_PATH}/tasks`, updatedTask);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

// export const filterTask = async (
//   empId,
//   startDate,
//   endDate,
//   taskTitle,
//   project
// ) => {
//   return _axios
//     .get(
//       `${PROJECT_PATH}/users/${empId}/tasks/${startDate} ${endDate} ${taskTitle} ${project}`
//     )
//     .catch((err) => console.log(err));
// };

export const deleteTask = async (empId, taskId) => {
  try {
    const response = await _axios.delete(
      `${PROJECT_PATH}/users/${empId}/tasks/${taskId}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};
